import { z } from "zod";

export const staffSchema = z.object({
  id: z.string().brand("staffId"),
  name: z.string(),
  nameKana: z.string(),
  postalCode: z.string(),
  address: z.string(),
  nearestStation: z.string().nullish(),
  isSocialInsurance: z.boolean(),
  isDisasterCenter: z.boolean().default(false),
  canWorkAtNight: z.boolean().default(false),
  isActive: z.boolean().default(true),
  createdAt: z
    .string()
    .or(z.date())
    .transform((val) => (typeof val === "string" ? val : val.toISOString())),
  updatedAt: z
    .string()
    .or(z.date())
    .transform((val) => (typeof val === "string" ? val : val.toISOString())),
});

export const editStaffSchema = staffSchema.pick({
  canWorkAtNight: true,
  isActive: true,
  isDisasterCenter: true,
});

export type Staff = z.infer<typeof staffSchema>;
export type StaffInput = z.input<typeof staffSchema>;
export type EditStaffInput = z.input<typeof editStaffSchema>;

export const newStaff = (input: StaffInput): Staff => staffSchema.parse(input);
export const createStaff = (input: StaffInput): Staff => newStaff(input);
export const editStaff = (input: EditStaffInput): EditStaffInput => editStaffSchema.parse(input);
